import React, { useMemo, useEffect } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { useGetExchangeRateListQuery } from '../../api/endpoints/sap';
import { useLanguage } from '../../contexts/LanguageContext';

const SapCurrencyDropdown = ({ value, onChange, className = '', disabled = false, placeholder, isDealer = false }) => {
    const { th } = useLanguage();
    const { data: currencyList = [], isLoading } = useGetExchangeRateListQuery({
        isDealer: isDealer
    });

    const currencyOptions = useMemo(() => {
        // Backend'den distinct f_from_currency geliyor
        return currencyList.map((item) => {
            const code = item.fFromCurrency || item.f_from_currency || item.currency || item;
            return {
                code: code,
                label: code
            };
        });
    }, [currencyList]);

    // Dealer ise ve backend'den tek para birimi geldiyse, otomatik olarak seç
    useEffect(() => {
        if (isDealer && !value && currencyOptions.length === 1) {
            const singleCurrency = currencyOptions[0];
            if (singleCurrency && onChange) {
                onChange({ value: singleCurrency.code });
            }
        }
    }, [isDealer, value, currencyOptions, onChange]);

    // Dealer ise dropdown'ı devre dışı bırak
    const isDisabled = disabled || isLoading || (isDealer && currencyOptions.length === 1);

    return (
        <Dropdown
            value={value}
            onChange={onChange}
            options={currencyOptions}
            optionLabel="label"
            optionValue="code"
            placeholder={placeholder || th('externalItemDescription.selectCurrency') || 'Select Currency'}
            className={className}
            disabled={isDisabled}
            filter
            showClear={!isDealer || currencyOptions.length !== 1}
            loading={isLoading}
        />
    );
};

export default SapCurrencyDropdown;

